import { roleAllowed, useUserStore } from "@/stores/userStore";
import type { RoleType } from "@repo/types";
import type { PropsWithChildren } from "react";

interface RoleProtectedProps extends PropsWithChildren {
  minRole: RoleType;
}

export const RoleProtected = ({ minRole, children }: RoleProtectedProps) => {
  const { activeRole } = useUserStore();
  if (!activeRole) {
    return null;
  }

  if (roleAllowed({ current: activeRole, required: minRole })) {
    return children;
  } else {
    return null;
  }
};
